import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";
import { StockTransferDto } from "./stock-transfer.dto";

export class SendStockDto {
    @ApiProperty({ type: [StockTransferDto]})
    @IsNotEmpty({message:"Recevied Stocks should not be empty"})
    sendStocks: StockTransferDto[];    
}